// extracted by mini-css-extract-plugin
export default {"tupacGrid":"vk-z","tupacHeader":"wk-z","tupacHeader2":"xk-z","tupacMenu":"yk-z","tupacMenu2":"zk-z","tupacMain":"Ak-z","tupacMain2":"Bk-z"};